import { useEffect, useState } from 'react'
import resolveConfig from 'tailwindcss/resolveConfig'

import * as tailwindConfig from '../../tailwind.config.js'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const tailwind = resolveConfig(tailwindConfig)
type ThemeType = 'light' | 'dark'

// Helper hook used to detect the preferred user theme on the browser.
const useDetectTheme = (): ThemeType => {
  const [theme, setTheme] = useState<ThemeType>('light')

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      !!window.matchMedia &&
      tailwind.darkMode === 'media'
    ) {
      const matchesDark = window.matchMedia('(prefers-color-scheme: dark)')

      setTheme(matchesDark.matches ? 'dark' : 'light')

      const updateThemeChanged = (evt: MediaQueryListEvent) => {
        if (evt.matches) {
          setTheme('dark')
        } else {
          setTheme('light')
        }
      }

      matchesDark.addEventListener('change', updateThemeChanged)

      return () => matchesDark.removeEventListener('change', updateThemeChanged)
    }
  }, [])

  return theme
}

export default useDetectTheme
